import React from "react";

const ShoppingCart = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M2.40039 2.3999H3.64483L3.89372 3.64435M4.88928 8.62212H11.1115L13.6004 3.64435H3.89372M4.88928 8.62212L3.89372 3.64435M4.88928 8.62212L3.46259 10.0488C3.07061 10.4408 3.34823 11.111 3.90257 11.111H11.1115M11.1115 11.111C10.4242 11.111 9.86706 11.6682 9.86706 12.3555C9.86706 13.0427 10.4242 13.5999 11.1115 13.5999C11.7988 13.5999 12.3559 13.0427 12.3559 12.3555C12.3559 11.6682 11.7988 11.111 11.1115 11.111ZM6.13372 12.3555C6.13372 13.0427 5.57657 13.5999 4.88928 13.5999C4.20199 13.5999 3.64483 13.0427 3.64483 12.3555C3.64483 11.6682 4.20199 11.111 4.88928 11.111C5.57657 11.111 6.13372 11.6682 6.13372 12.3555Z"
            stroke="currentColor"
            strokeWidth="1.67"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ShoppingCart;
